import { useTranslation } from 'react-i18next';

import { useData } from '@cold-ambulance/ui';

import { NewRequestButton } from '../../components/new-request-button.tsx';
import {
  RequestCard,
  RequestCardSkeleton,
} from '../../components/request-card.tsx';
import { RequestDraftCard } from '../../components/request-draft-card.tsx';

export default function RequestsPage() {
  const { t } = useTranslation();
  const draftsQuery = useData('GET /me/request-drafts');
  const requestsQuery = useData('GET /me/requests', {
    pageSize: 10,
  });

  return (
    <div className="page-container">
      <div className="mx-auto w-full max-w-3xl">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold">{t('requests.myRequests')}</h1>
          <NewRequestButton />
        </div>

        <section className="mt-8">
          <div className="mb-4 flex items-center justify-between gap-3">
            <h2 className="text-xl font-bold">{t('requests.draftsTitle')}</h2>
            <span className="text-muted-foreground text-sm">
              {draftsQuery.data?.length ?? 0}
            </span>
          </div>

          {draftsQuery.isLoading ? (
            <div className="grid grid-cols-2 gap-4">
              <RequestCardSkeleton />
              <RequestCardSkeleton />
            </div>
          ) : draftsQuery.data?.length ? (
            <div className="grid grid-cols-2 gap-4">
              {draftsQuery.data.map((draft) => (
                <RequestDraftCard key={draft.id} draft={draft} />
              ))}
            </div>
          ) : (
            <p className="text-muted-foreground rounded-lg border border-dashed p-6 text-sm">
              {t('requests.noDrafts')}
            </p>
          )}
        </section>

        <section className="mt-10">
          <h2 className="text-xl font-bold">
            {t('requests.submittedRequests')}
          </h2>

          {requestsQuery.isLoading ? (
            <div className="mt-4 grid grid-cols-2 gap-4">
              <RequestCardSkeleton />
              <RequestCardSkeleton />
              <RequestCardSkeleton />
              <RequestCardSkeleton />
            </div>
          ) : requestsQuery.data?.records.length ? (
            <div className="mt-4 grid grid-cols-2 gap-4">
              {requestsQuery.data.records.map((request) => (
                <RequestCard key={request.id} request={request} />
              ))}
            </div>
          ) : (
            <p className="text-muted-foreground mt-4 rounded-lg border border-dashed p-6 text-sm">
              {t('home.noRequestsDescription')}
            </p>
          )}
        </section>
      </div>
    </div>
  );
}
